module.exports = __webpack_public_path__ + "img/botox-logo.f512a947.svg";